import React from 'react';
import { motion } from 'framer-motion';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        <motion.div
          className="md:col-span-4"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-block mb-3 text-xs font-bold tracking-widest text-serchon-gold uppercase">
            关于我们
          </div>
          <h2 className="font-serif text-4xl mb-6 leading-tight text-stone-900">公司简介</h2>
          <div className="w-16 h-1 bg-serchon-gold mb-6"></div>
        </motion.div>

        <motion.div
          className="md:col-span-8 text-lg text-stone-600 leading-relaxed space-y-6"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p>
            <span className="text-5xl float-left mr-3 mt-[-8px] font-serif text-serchon-gold">江</span>
            西溯玄科技有限公司成立于2025年09月30日，是一家专注于人工智能、软件开发、数据处理等领域的高新技术企业。公司以"技术创新、服务至上"为核心理念，致力于为客户提供卓越的技术解决方案。
          </p>
          <p>
            公司经营范围涵盖<strong>人工智能应用软件开发</strong>、<strong>人工智能基础软件开发</strong>、<strong>数据处理服务</strong>、<strong>软件开发</strong>、<strong>软件外包服务</strong>、<strong>信息技术咨询服务</strong>、<strong>信息系统集成服务</strong>、<strong>软件销售</strong>、<strong>计算机系统服务</strong>等多个领域。
          </p>
          <p>
            我们拥有一支经验丰富的技术团队，深耕行业多年，能够深入理解客户需求，提供专业的技术解决方案。公司始终坚持以客户为中心的服务理念，严格的质量管理体系，从需求分析到交付上线，全程把控项目质量，确保交付成果。
          </p>
          <div className="bg-[#F9F8F4] p-6 rounded-xl border border-stone-200 border-l-4 border-l-serchon-gold">
            <p className="font-serif italic text-xl text-stone-800 mb-4">
              "以科技创新为驱动，以客户满意为目标，成为值得信赖的技术合作伙伴。"
            </p>
            <span className="text-sm font-bold text-stone-500 tracking-wider uppercase">— 溯玄科技</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
